// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./expenseEditor.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expense-details {
  width: calc(100% + 48px);
  min-height: calc(100vh - 72px);
  box-sizing: border-box;
  margin: 0 -24px -8px;
  padding: 32px;
  background: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
  font: 400 13px var(--font-family-primary, "Lexend", sans-serif);
}
.expense-details button {
  font: inherit;
}
.expense-details__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin: 8px 0 28px;
}
.expense-details__header h1 {
  margin: 0;
  font-size: 32px;
  line-height: 40px;
}
.expense-details__header p {
  margin: 2px 0;
  color: var(--text-secondary, #506360);
}
.expense-details__header > button,
.expense-detail-secondary {
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  cursor: pointer;
}
.expense-details__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.expense-details__actions .expense-primary {
  min-height: 40px;
  padding-inline: 14px;
}
.expense-detail-badges {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.expense-detail-badges span,
.expense-detail-badge {
  padding: 4px 7px;
  border-radius: 999px;
  background: var(--success-soft, #edf9f1);
  color: var(--success-text, #105b32);
  font-size: 11px;
}
.expense-detail-badges .warning,
.expense-detail-badge.warning {
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}
.expense-details__layout {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  align-items: start;
}
.expense-details__main,
.expense-details__aside {
  display: grid;
  gap: 20px;
}
.expense-details__aside {
  position: sticky;
  top: 84px;
}
.expense-detail-card {
  padding: 24px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
}
.expense-detail-card h2 {
  margin: 0 0 18px;
  font-size: 16px;
  font-weight: 500;
}
.expense-detail-card h3 {
  margin: 10px 0;
  font-size: 16px;
}
.expense-detail-card p {
  color: var(--text-secondary, #506360);
  line-height: 1.55;
}
.expense-detail-reference {
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.expense-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  padding: 16px 0;
}
.expense-detail-grid .wide {
  grid-column: 1/-1;
}
.expense-detail-grid div {
  display: grid;
  gap: 5px;
}
.expense-detail-grid span {
  color: var(--text-secondary, #506360);
}
.expense-detail-money {
  margin: 0;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  overflow: hidden;
}
.expense-detail-money div,
.expense-detail-balance {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.expense-detail-money div:last-child {
  border: 0;
}
.expense-detail-money dt,
.expense-detail-money dd {
  margin: 0;
}
.expense-detail-money dd,
.expense-detail-total,
.expense-detail-balance strong {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
}
.expense-detail-total {
  display: block;
  font-size: 22px;
}
.expense-detail-tabs {
  display: flex;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.expense-detail-tabs button {
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.expense-detail-tabs button.active {
  border-bottom-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}
.expense-detail-note {
  display: grid;
  gap: 6px;
  padding: 14px;
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
}
.expense-record-payment {
  width: 100%;
  min-height: 40px;
  margin-top: 16px;
}
.expense-payment-history {
  display: grid;
  gap: 8px;
  margin-top: 16px;
}
.expense-payment-history > div {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 16px;
  padding: 12px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
}
.expense-payment-history strong {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
}
.expense-payment-history small {
  grid-column: 1 / -1;
  color: var(--text-secondary, #506360);
}
.expense-payment-overlay {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: grid;
  place-items: center;
  padding: 24px;
  overflow: auto;
  background: var(--overlay-default, rgb(0 0 0 / 45%));
}
.expense-payment-dialog {
  position: relative;
  box-sizing: border-box;
  width: min(676px, 100%);
  padding: 24px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  max-height: calc(100dvh - 48px);
  overflow: auto;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  box-shadow: var(--elevation-large, 0 24px 48px -12px rgb(14 26 32 / 22%));
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.expense-payment-dialog h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 22.4px;
  letter-spacing: -0.08px;
}
.expense-payment-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.expense-payment-grab,
.expense-payment-mobile-close {
  display: none;
}
.expense-payment-supplier {
  margin: 16px 0;
  font-size: 13px;
  line-height: 20.2px;
}
.expense-payment-balance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.expense-payment-balance strong {
  color: var(--text-primary, #142624);
  font: 500 15px/19.5px var(--font-family-mono, "JetBrains Mono", monospace);
}
.expense-payment-dialog form > label,
.expense-payment-pending > label {
  display: grid;
  gap: 6px;
  margin-top: 16px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.expense-payment-form > label {
  margin: 0 !important;
}
.expense-payment-form > .expense-payment-method-field {
  gap: 4px;
}
.expense-payment-dialog input,
.expense-payment-dialog .quotation-figma-dropdown-trigger {
  width: 100%;
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 400 13px/20.2px var(--font-family-primary, "Lexend", sans-serif);
}
.expense-payment-dialog .quotation-figma-dropdown {
  width: 100%;
}
.expense-payment-dialog input:hover:not(:disabled):not(:focus),
.expense-payment-dialog
  .quotation-figma-dropdown:not(.is-open)
  .quotation-figma-dropdown-trigger:hover:not(:disabled):not(:focus-visible) {
  border-color: var(--border-strong, #8b9996);
}
.expense-payment-dialog input:focus,
.expense-payment-dialog .quotation-figma-dropdown-trigger:focus-visible,
.expense-payment-dialog .quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger {
  border-color: var(--focus-ring, #0f766e);
  box-shadow: none;
  outline: 0;
}
.expense-payment-dialog label.has-error input,
.expense-payment-dialog label.has-error .quotation-figma-dropdown-trigger {
  border-color: var(--danger-border, #fbc5c0);
  box-shadow: none;
}
.expense-payment-dialog label > small {
  color: var(--danger-text, #a3301f);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.expense-payment-balance.is-projected {
  margin: 18px 0 0;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.expense-payment-help,
.expense-payment-footnote {
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 20.2px;
}
.expense-payment-error-banner,
.expense-payment-method-error,
.expense-payment-guidance {
  display: flex;
  gap: 10px;
  margin-top: 16px;
  padding: 12px;
  border: 1px solid var(--danger-border, #fbc5c0);
  border-radius: var(--radius-md, 10px);
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
  font-size: 13px;
  line-height: 20.2px;
}
.expense-payment-error-banner > svg,
.expense-payment-method-error > svg {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  margin-top: 1px;
}
.expense-payment-error-banner > div,
.expense-payment-method-error > div,
.expense-payment-guidance {
  display: grid;
  gap: 2px;
}
.expense-payment-error-banner small {
  color: inherit;
  opacity: 0.9;
}
.expense-payment-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
}
.expense-payment-actions .expense-primary,
.expense-payment-actions .expense-detail-secondary {
  height: 44px;
  min-height: 44px;
  width: auto;
  margin: 0;
  padding-inline: 12px;
  font: 500 13px/normal var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0;
}
.expense-payment-footnote {
  margin: 18px 0 0;
}
.expense-payment-form > .expense-payment-supplier,
.expense-payment-form > .expense-payment-balance,
.expense-payment-form > .expense-payment-error-banner,
.expense-payment-form > .expense-payment-method-error,
.expense-payment-form > .expense-payment-help,
.expense-payment-form > .expense-payment-actions,
.expense-payment-form > .expense-payment-footnote {
  margin: 0;
}
.expense-payment-form > .expense-payment-balance.is-projected {
  margin: 0;
  padding-top: 0;
  border-top: 0;
}
.expense-payment-result {
  display: grid;
  gap: 16px;
}
.expense-payment-success-title {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.expense-payment-success-title > svg {
  width: 22px;
  height: 22px;
  flex: 0 0 auto;
  color: var(--success-default, #15703d);
}
.expense-payment-success-title p {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 20.2px;
}
.expense-payment-result-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.expense-payment-result-badges span,
.expense-payment-status {
  width: -moz-fit-content;
  width: fit-content;
  padding: 4px 7px;
  border-radius: 999px;
  background: var(--success-soft, #edfbf2);
  color: var(--success-text, #115a33);
  font-size: 11px;
  font-weight: 500;
  line-height: 14.3px;
  letter-spacing: 0.11px;
}
.expense-payment-result-badges .warning {
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}
.expense-payment-status {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}
.expense-payment-result dl {
  margin: 0;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  overflow: hidden;
}
.expense-payment-result dl div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.expense-payment-result dl div:last-child {
  border-bottom: 0;
}
.expense-payment-result dt,
.expense-payment-result dd {
  margin: 0;
}
.expense-payment-result dd {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 15px;
  font-weight: 500;
}
.expense-payment-result-history {
  display: grid;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
  font-size: 13px;
  line-height: 20.2px;
}
.expense-payment-result-history > span {
  color: var(--text-secondary, #506360);
}
.expense-payment-guidance {
  margin: 0;
  border-color: var(--border-subtle, #dce3e2);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}
.expense-payment-guidance span {
  color: var(--text-secondary, #506360);
}
.expense-payment-pending,
.expense-payment-review {
  display: grid;
  gap: 16px;
}
.expense-payment-pending > p,
.expense-payment-review > p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 20.2px;
}
.expense-payment-pending > label {
  margin: 0 !important;
}
.expense-payment-pending > .expense-primary {
  width: -moz-fit-content;
  width: fit-content;
  min-height: 44px;
  margin: 0;
  padding: 0 12px;
}
.expense-payment-pending .expense-payment-balance,
.expense-payment-review .expense-payment-balance,
.expense-payment-pending .expense-payment-help,
.expense-payment-pending .expense-payment-footnote,
.expense-payment-review .expense-payment-footnote {
  margin: 0;
}
.expense-detail-empty {
  margin-top: 24px;
  padding: 40px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  text-align: center;
  background: var(--surface-primary, #fff);
}
@media (max-width: 1000px) {
  .expense-details__layout {
    grid-template-columns: 1fr;
  }
  .expense-details__aside {
    position: static;
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 600px) {
  .expense-details {
    width: calc(100% + 48px);
    padding: 20px 16px;
  }
  .expense-details__header {
    display: block;
  }
  .expense-details__header h1 {
    font-size: 24px;
    line-height: 30px;
  }
  .expense-details__header > button {
    margin-top: 16px;
  }
  .expense-details__actions {
    margin-top: 16px;
    align-items: stretch;
  }
  .expense-details__actions > button {
    flex: 1 1;
  }
  .expense-detail-badges {
    flex-wrap: wrap;
  }
  .expense-detail-grid {
    grid-template-columns: 1fr;
  }
  .expense-detail-grid .wide {
    grid-column: auto;
  }
  .expense-details__aside {
    grid-template-columns: 1fr;
  }
  .expense-detail-tabs {
    overflow-x: auto;
  }
  .expense-detail-tabs button {
    white-space: nowrap;
  }
  .expense-payment-overlay {
    align-items: end;
    padding: 0;
  }
  .expense-payment-dialog {
    width: min(100%, 390px);
    max-height: calc(100dvh - 16px);
    overflow-y: auto;
    border-radius: 20px 20px 0 0;
    padding: 24px;
  }
  .expense-payment-grab {
    display: block;
    width: 40px;
    height: 4px;
    margin: -12px auto 16px;
    border-radius: 999px;
    background: var(--border-strong, #9aa8a6);
  }
  .expense-payment-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }
  .expense-payment-actions > button {
    width: 100%;
    justify-content: center;
  }
  .expense-payment-dialog form .expense-payment-actions .expense-detail-secondary {
    display: none;
  }
  .expense-payment-mobile-close {
    display: flex;
    width: 100%;
    min-height: 44px;
    margin-top: -4px;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: var(--radius-md, 10px);
    background: transparent;
    color: var(--interactive-default, #0f766e);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
  }
  .expense-payment-result .expense-payment-actions,
  .expense-payment-review .expense-payment-actions {
    flex-direction: column-reverse;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Expenses/expenseDetails.css"],"names":[],"mappings":"AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,+DAA+D;AACjE;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;AACjB;AACA;;EAEE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,WAAW;EACX,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sDAAsD;AACxD;AACA;EACE,SAAS;AACX;AACA;;EAEE,SAAS;AACX;AACA;;;EAGE,iEAAiE;AACnE;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,wDAAwD;EACxD,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;AACvC;AACA;EACE,iEAAiE;AACnE;AACA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,+BAA+B;EAC/B,cAAc;EACd,wCAAwC;EACxC,mCAAmC;EACnC,yEAAyE;EACzE,6DAA6D;AAC/D;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,0EAA0E;AAC5E;AACA;;EAEE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,QAAQ;AACV;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,sEAAsE;AACxE;AACA;EACE,WAAW;AACb;AACA;;;;EAIE,2CAA2C;AAC7C;AACA;;;EAGE,wCAAwC;EACxC,gBAAgB;EAChB,UAAU;AACZ;AACA;;EAEE,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;;EAEE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;;;EAGE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,uCAAuC;EACvC,kCAAkC;EAClC,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;;;EAGE,aAAa;EACb,QAAQ;AACV;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,sEAAsE;EACtE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;EAOE,SAAS;AACX;AACA;EACE,SAAS;EACT,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;;EAEE,uBAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,+CAA+C;EAC/C,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sDAAsD;AACxD;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,SAAS;AACX;AACA;EACE,iEAAiE;EACjE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mDAAmD;EACnD,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,2CAA2C;EAC3C,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;AACA;;;;;EAKE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;AACF;AACA;EACE;IACE,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,SAAO;EACT;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,yCAAyC;EAC3C;EACA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,qCAAqC;IACrC,uBAAuB;IACvB,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;EACA;;IAEE,8BAA8B;EAChC;AACF","sourcesContent":["@import \"./expenseEditor.css\";\n.expense-details {\n  width: calc(100% + 48px);\n  min-height: calc(100vh - 72px);\n  box-sizing: border-box;\n  margin: 0 -24px -8px;\n  padding: 32px;\n  background: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font: 400 13px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.expense-details button {\n  font: inherit;\n}\n.expense-details__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n  margin: 8px 0 28px;\n}\n.expense-details__header h1 {\n  margin: 0;\n  font-size: 32px;\n  line-height: 40px;\n}\n.expense-details__header p {\n  margin: 2px 0;\n  color: var(--text-secondary, #506360);\n}\n.expense-details__header > button,\n.expense-detail-secondary {\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n}\n.expense-details__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.expense-details__actions .expense-primary {\n  min-height: 40px;\n  padding-inline: 14px;\n}\n.expense-detail-badges {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n.expense-detail-badges span,\n.expense-detail-badge {\n  padding: 4px 7px;\n  border-radius: 999px;\n  background: var(--success-soft, #edf9f1);\n  color: var(--success-text, #105b32);\n  font-size: 11px;\n}\n.expense-detail-badges .warning,\n.expense-detail-badge.warning {\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n.expense-details__layout {\n  display: grid;\n  width: 100%;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 24px;\n  align-items: start;\n}\n.expense-details__main,\n.expense-details__aside {\n  display: grid;\n  gap: 20px;\n}\n.expense-details__aside {\n  position: sticky;\n  top: 84px;\n}\n.expense-detail-card {\n  padding: 24px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n}\n.expense-detail-card h2 {\n  margin: 0 0 18px;\n  font-size: 16px;\n  font-weight: 500;\n}\n.expense-detail-card h3 {\n  margin: 10px 0;\n  font-size: 16px;\n}\n.expense-detail-card p {\n  color: var(--text-secondary, #506360);\n  line-height: 1.55;\n}\n.expense-detail-reference {\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.expense-detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px;\n  padding: 16px 0;\n}\n.expense-detail-grid .wide {\n  grid-column: 1/-1;\n}\n.expense-detail-grid div {\n  display: grid;\n  gap: 5px;\n}\n.expense-detail-grid span {\n  color: var(--text-secondary, #506360);\n}\n.expense-detail-money {\n  margin: 0;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  overflow: hidden;\n}\n.expense-detail-money div,\n.expense-detail-balance {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.expense-detail-money div:last-child {\n  border: 0;\n}\n.expense-detail-money dt,\n.expense-detail-money dd {\n  margin: 0;\n}\n.expense-detail-money dd,\n.expense-detail-total,\n.expense-detail-balance strong {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.expense-detail-total {\n  display: block;\n  font-size: 22px;\n}\n.expense-detail-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.expense-detail-tabs button {\n  padding: 10px 14px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.expense-detail-tabs button.active {\n  border-bottom-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n.expense-detail-note {\n  display: grid;\n  gap: 6px;\n  padding: 14px;\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n.expense-record-payment {\n  width: 100%;\n  min-height: 40px;\n  margin-top: 16px;\n}\n.expense-payment-history {\n  display: grid;\n  gap: 8px;\n  margin-top: 16px;\n}\n.expense-payment-history > div {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 4px 16px;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n}\n.expense-payment-history strong {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.expense-payment-history small {\n  grid-column: 1 / -1;\n  color: var(--text-secondary, #506360);\n}\n.expense-payment-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  overflow: auto;\n  background: var(--overlay-default, rgb(0 0 0 / 45%));\n}\n.expense-payment-dialog {\n  position: relative;\n  box-sizing: border-box;\n  width: min(676px, 100%);\n  padding: 24px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  max-height: calc(100dvh - 48px);\n  overflow: auto;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  box-shadow: var(--elevation-large, 0 24px 48px -12px rgb(14 26 32 / 22%));\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.expense-payment-dialog h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22.4px;\n  letter-spacing: -0.08px;\n}\n.expense-payment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.expense-payment-grab,\n.expense-payment-mobile-close {\n  display: none;\n}\n.expense-payment-supplier {\n  margin: 16px 0;\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.expense-payment-balance {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.expense-payment-balance strong {\n  color: var(--text-primary, #142624);\n  font: 500 15px/19.5px var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.expense-payment-dialog form > label,\n.expense-payment-pending > label {\n  display: grid;\n  gap: 6px;\n  margin-top: 16px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.expense-payment-form > label {\n  margin: 0 !important;\n}\n.expense-payment-form > .expense-payment-method-field {\n  gap: 4px;\n}\n.expense-payment-dialog input,\n.expense-payment-dialog .quotation-figma-dropdown-trigger {\n  width: 100%;\n  min-height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 400 13px/20.2px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.expense-payment-dialog .quotation-figma-dropdown {\n  width: 100%;\n}\n.expense-payment-dialog input:hover:not(:disabled):not(:focus),\n.expense-payment-dialog\n  .quotation-figma-dropdown:not(.is-open)\n  .quotation-figma-dropdown-trigger:hover:not(:disabled):not(:focus-visible) {\n  border-color: var(--border-strong, #8b9996);\n}\n.expense-payment-dialog input:focus,\n.expense-payment-dialog .quotation-figma-dropdown-trigger:focus-visible,\n.expense-payment-dialog .quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger {\n  border-color: var(--focus-ring, #0f766e);\n  box-shadow: none;\n  outline: 0;\n}\n.expense-payment-dialog label.has-error input,\n.expense-payment-dialog label.has-error .quotation-figma-dropdown-trigger {\n  border-color: var(--danger-border, #fbc5c0);\n  box-shadow: none;\n}\n.expense-payment-dialog label > small {\n  color: var(--danger-text, #a3301f);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.expense-payment-balance.is-projected {\n  margin: 18px 0 0;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.expense-payment-help,\n.expense-payment-footnote {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.expense-payment-error-banner,\n.expense-payment-method-error,\n.expense-payment-guidance {\n  display: flex;\n  gap: 10px;\n  margin-top: 16px;\n  padding: 12px;\n  border: 1px solid var(--danger-border, #fbc5c0);\n  border-radius: var(--radius-md, 10px);\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.expense-payment-error-banner > svg,\n.expense-payment-method-error > svg {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 auto;\n  margin-top: 1px;\n}\n.expense-payment-error-banner > div,\n.expense-payment-method-error > div,\n.expense-payment-guidance {\n  display: grid;\n  gap: 2px;\n}\n.expense-payment-error-banner small {\n  color: inherit;\n  opacity: 0.9;\n}\n.expense-payment-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 18px;\n}\n.expense-payment-actions .expense-primary,\n.expense-payment-actions .expense-detail-secondary {\n  height: 44px;\n  min-height: 44px;\n  width: auto;\n  margin: 0;\n  padding-inline: 12px;\n  font: 500 13px/normal var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0;\n}\n.expense-payment-footnote {\n  margin: 18px 0 0;\n}\n.expense-payment-form > .expense-payment-supplier,\n.expense-payment-form > .expense-payment-balance,\n.expense-payment-form > .expense-payment-error-banner,\n.expense-payment-form > .expense-payment-method-error,\n.expense-payment-form > .expense-payment-help,\n.expense-payment-form > .expense-payment-actions,\n.expense-payment-form > .expense-payment-footnote {\n  margin: 0;\n}\n.expense-payment-form > .expense-payment-balance.is-projected {\n  margin: 0;\n  padding-top: 0;\n  border-top: 0;\n}\n.expense-payment-result {\n  display: grid;\n  gap: 16px;\n}\n.expense-payment-success-title {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n.expense-payment-success-title > svg {\n  width: 22px;\n  height: 22px;\n  flex: 0 0 auto;\n  color: var(--success-default, #15703d);\n}\n.expense-payment-success-title p {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.expense-payment-result-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.expense-payment-result-badges span,\n.expense-payment-status {\n  width: fit-content;\n  padding: 4px 7px;\n  border-radius: 999px;\n  background: var(--success-soft, #edfbf2);\n  color: var(--success-text, #115a33);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14.3px;\n  letter-spacing: 0.11px;\n}\n.expense-payment-result-badges .warning {\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n.expense-payment-status {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n.expense-payment-result dl {\n  margin: 0;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  overflow: hidden;\n}\n.expense-payment-result dl div {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.expense-payment-result dl div:last-child {\n  border-bottom: 0;\n}\n.expense-payment-result dt,\n.expense-payment-result dd {\n  margin: 0;\n}\n.expense-payment-result dd {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 15px;\n  font-weight: 500;\n}\n.expense-payment-result-history {\n  display: grid;\n  gap: 8px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.expense-payment-result-history > span {\n  color: var(--text-secondary, #506360);\n}\n.expense-payment-guidance {\n  margin: 0;\n  border-color: var(--border-subtle, #dce3e2);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n.expense-payment-guidance span {\n  color: var(--text-secondary, #506360);\n}\n.expense-payment-pending,\n.expense-payment-review {\n  display: grid;\n  gap: 16px;\n}\n.expense-payment-pending > p,\n.expense-payment-review > p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.expense-payment-pending > label {\n  margin: 0 !important;\n}\n.expense-payment-pending > .expense-primary {\n  width: fit-content;\n  min-height: 44px;\n  margin: 0;\n  padding: 0 12px;\n}\n.expense-payment-pending .expense-payment-balance,\n.expense-payment-review .expense-payment-balance,\n.expense-payment-pending .expense-payment-help,\n.expense-payment-pending .expense-payment-footnote,\n.expense-payment-review .expense-payment-footnote {\n  margin: 0;\n}\n.expense-detail-empty {\n  margin-top: 24px;\n  padding: 40px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  text-align: center;\n  background: var(--surface-primary, #fff);\n}\n@media (max-width: 1000px) {\n  .expense-details__layout {\n    grid-template-columns: 1fr;\n  }\n  .expense-details__aside {\n    position: static;\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 600px) {\n  .expense-details {\n    width: calc(100% + 48px);\n    padding: 20px 16px;\n  }\n  .expense-details__header {\n    display: block;\n  }\n  .expense-details__header h1 {\n    font-size: 24px;\n    line-height: 30px;\n  }\n  .expense-details__header > button {\n    margin-top: 16px;\n  }\n  .expense-details__actions {\n    margin-top: 16px;\n    align-items: stretch;\n  }\n  .expense-details__actions > button {\n    flex: 1;\n  }\n  .expense-detail-badges {\n    flex-wrap: wrap;\n  }\n  .expense-detail-grid {\n    grid-template-columns: 1fr;\n  }\n  .expense-detail-grid .wide {\n    grid-column: auto;\n  }\n  .expense-details__aside {\n    grid-template-columns: 1fr;\n  }\n  .expense-detail-tabs {\n    overflow-x: auto;\n  }\n  .expense-detail-tabs button {\n    white-space: nowrap;\n  }\n  .expense-payment-overlay {\n    align-items: end;\n    padding: 0;\n  }\n  .expense-payment-dialog {\n    width: min(100%, 390px);\n    max-height: calc(100dvh - 16px);\n    overflow-y: auto;\n    border-radius: 20px 20px 0 0;\n    padding: 24px;\n  }\n  .expense-payment-grab {\n    display: block;\n    width: 40px;\n    height: 4px;\n    margin: -12px auto 16px;\n    border-radius: 999px;\n    background: var(--border-strong, #9aa8a6);\n  }\n  .expense-payment-actions {\n    align-items: stretch;\n    flex-direction: column-reverse;\n  }\n  .expense-payment-actions > button {\n    width: 100%;\n    justify-content: center;\n  }\n  .expense-payment-dialog form .expense-payment-actions .expense-detail-secondary {\n    display: none;\n  }\n  .expense-payment-mobile-close {\n    display: flex;\n    width: 100%;\n    min-height: 44px;\n    margin-top: -4px;\n    align-items: center;\n    justify-content: center;\n    border: 0;\n    border-radius: var(--radius-md, 10px);\n    background: transparent;\n    color: var(--interactive-default, #0f766e);\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n  }\n  .expense-payment-result .expense-payment-actions,\n  .expense-payment-review .expense-payment-actions {\n    flex-direction: column-reverse;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
